export default {
    GET_LENOVO_LANGUAGE: 'GET_LENOVO_LANGUAGE',
    GET_USER_INFO: 'GET_USER_INFO',
    GET_LENOVO_ACCOUNT_INFO: 'GET_LENOVO_ACCOUNT_INFO',
    GET_LENOVO_CUSTOMIZE_INFO: 'GET_LENOVO_CUSTOMIZE_INFO',
    GET_SESSION: 'GET_SESSION',
    SET_ISLOADING: 'SET_ISLOADING',
    CANCEL_ISLOADING: 'CANCEL_ISLOADING',
    // 链接安全管控-start
    SET_LM_GLOBAL_RULES: 'SET_LM_GLOBAL_RULES',
    GET_LM_GLOBAL_RULES: 'GET_LM_GLOBAL_RULES',
    SET_LmDetail_ISLOADING: 'SET_LmDetail_ISLOADING',
    CANCEL_LmDetail_ISLOADING: 'CANCEL_LmDetail_ISLOADING',
    SET_LM_GLOBAL_READY: 'SET_LM_GLOBAL_READY',
    // 链接安全管控-end
    //企业版管理员角色
    GET_USER_ROLE: 'TYPES.GET_USER_ROLE',
    SET_SEARCH_CANCEL: 'SET_SEARCH_CANCEL',
    //验证码状态框
    SET_ERRCOUNT: 'SET_ERRCOUNT',
    CANCEL_ERRCOUNT: 'CANCEL_ERRCOUNT',
    GET_SESSION_ID: 'GET_SESSION_ID'
}



// WEBPACK FOOTER //
// ./store/types.js